import dayjs from "dayjs";

type PatientEncounterLike = {
  id: string;
  admit_datetime?: string | null;
  integration_encounter_id?: string | null;
};

export function getPatientEncounterLabel(encounter: PatientEncounterLike | null | undefined): string {
  if (!encounter) {
    return "Unknown";
  }

  if (encounter.integration_encounter_id) {
    return encounter.integration_encounter_id;
  }

  if (encounter.admit_datetime) {
    return dayjs(encounter.admit_datetime).format("DD/MM/YYYY HH:mm");
  }

  return encounter.id;
}
